<template>
    <div class="story-footer">
        <a :href="storyUrl" target="_blank" rel="noopener" class="btn-read-full">
            Read full story
            <ion-icon name="ios-arrow-round-forward"></ion-icon>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            storyUrl: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped>
    .story-footer {
        text-align: center;
    }

    .btn-read-full {
        background-color: #000;
        padding: 8px 20px;
        /* border: 1px solid #171717; */
        border-radius: 25px;
        font-size: 13px;
        /* font-weight: 600; */
        color: #fff;
        /* text-decoration: underline; */
        -webkit-transition: 0.3s all ease;
        transition: 0.3s all ease;
    }

    .btn-read-full:hover {
        background-color: #51c715;
        color: #fff;
    }

    ion-icon {
        vertical-align: middle;
    }
</style>


// WEBPACK FOOTER //
// src/components/story/StoryFooter.vue